<div class="role-panel col-12 d-flex justify-content-between align-items-center tab-items-section"
  [ngClass]="{'role-align my-2': (viewLocation!=='coverage-report')}" id="tabPanel">
  <div class="col-auto p-0" id="tabContainer" role="tablist">

    <button type="button" tab-item="true" *ngFor="let item of tabItems; let i = index" role="tab"
      [ngClass]="(currentTab && currentTab.toLowerCase()===item.toLowerCase())?'tab_selected':''"
      [attr.aria-selected]="(currentTab && currentTab.toLowerCase()===item.toLowerCase())?true:false"
      attr.aria-controls="{{item.toLowerCase()}}" id="{{item.split(' ').join('').toLowerCase()}}Tab"
      class="btn btn-clear tab font-bold text-capitalize" (click)="onTabSelected(item)" [attr.tabindex]="(currentTab && currentTab.toLowerCase()===item.toLowerCase())?null:-1">{{item}} <span class="unread-count"
        *ngIf="counts.length > 0">{{counts[i]}}</span></button>
    <br>
    <!-- dont remove this br. this is a hack for the accessibility -->

  </div>

  <div *ngIf="showCheckbox" class="custom-control custom-checkbox">
    <input class="custom-control-input" [checked]='enableEmail === 1' id="emailConcent" type="checkbox"
      (click)="enableEmail=(enableEmail===0 ? 1 :0);setOption()">
    <label class="custom-control-label" id="emailConcentLabel" for="emailConcent">Receive e-mail notification.</label>
  </div>

  <div *ngIf="showVersionBtn" class="col-auto d-flex align-items-center justify-content-between new-version mb-1">
    <em class="material-icons-outlined font-4x animate__animated animate__swing animate__slow animate__repeat-5 animate__delay-3s" aria-hidden="true">notifications</em>
    <button type="button" class="btn" id="versionModalBtn" data-toggle="modal" data-target="#versionModal"
      (click)="loadVersionReport()">New
      Version Available<span class="sr-only">Opens in a new dialog</span></button>
    <button type="button" class="btn btn-clear p-1 font-3x" aria-label="Close" (click)="showVersionBtn=false">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

</div>